import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import {Form} from "react-bootstrap";
import {
    saveGuestRequirements,
    prevStepAction,
    nextStepAction
} from "~/redux/actions/guests";
import {toggleArray} from "~/services/helpers";
import ToggleSwitch from '../../../Components/ToggleSwitch/ToggleSwitch';
import StepsNavigation from '../StepsNavigation';
import {getTranslated} from "~/Components/ContentTranslate/Translate";
import TextTranslate from '../../../Components/TextTranslate/TextTranslate';
import { updateGuestFormUtil } from '../Utils/utils';

const SpecialRequirements = ({
    formData,
    activeGuest,
    activeStep,
    dietaries,
    guests,
    currentLanguage,
    isAdmin=false,
    ...props}) =>
{

    const [error, setError] = useState(null);
    const [showOther, setShowOther] = useState(false);

    const guest = !isAdmin ? guests[activeGuest] : guests;
    let form = !isAdmin ? formData[activeGuest][activeStep[activeGuest]] : formData;

    const defaultValues = {
        dietary: [],
        other_dietary: '',
        medical_needs: false,
        medical_comments: '',
        wheelchair: false,
        mobility_comments: '',
    };

    form = {...defaultValues, ...form};

    const handleTextInput = (event, name) => {
        form[name] = event.target.value;

        updateGuestFormUtil(form, isAdmin, props.onChange, props.dispatch);
    }

    const handleSwitch = (event, name) => {
        form[name] = !form[name];

        updateGuestFormUtil(form, isAdmin, props.onChange, props.dispatch);
    }

    const handleDietaryChange = (event) => {

        const value = parseInt(event.target.value);

        if (value === 0) {
            form.dietary = [];
        } else {
            form.dietary = toggleArray(form.dietary, value);
        }

        updateGuestFormUtil(form, isAdmin, props.onChange, props.dispatch);
    }

    const handlePrevious = () => {
        props.dispatch(prevStepAction());
    }

    const handleNext = () => {
        let promise = props.dispatch(saveGuestRequirements(guest.id, form));

        promise.then((data) => {
            setError(null);

            props.dispatch(nextStepAction());

        }).catch(error => setError(error.data));
    }

    useEffect(() => {
        setError(props?.errors);
    }, [props?.errors])

    useEffect(() => {
        setShowOther(form?.other_dietary?.length > 0)
    }, []);


    return (
        <>
            <div className="row">
                <div className="dietary-section col-12">
                    {error?.message && (
                        <div className="alert alert-danger" role="alert">
                            {error.message}
                        </div>
                    )}
                    <h3><TextTranslate name="form-dietary" fallback="Dietary"/></h3>
                    <p><TextTranslate name="form-dietary-note" fallback="Do you have any special dietary requirements? Please specify."/></p>

                    <div className="dietary-checks">
                        <div className="form-check form-check-inline grid-full w-100">
                            <input onChange={(e) => handleDietaryChange(e)}
                                value={0}
                                checked={form.dietary.length === 0}
                                id="dietary-0"
                                className="form-check-input" type="checkbox"/>
                            <label htmlFor="dietary-0" className="form-check-label">
                                <TextTranslate name="word-none" fallback="None" textOnly/>
                            </label>
                        </div>
                        {dietaries.map((dietary, key) => {
                            return (
                                <Form.Check
                                    key={key}
                                    inline
                                    label={getTranslated(dietary, 'name', currentLanguage)}
                                    type="checkbox"
                                    id={'dietary-' + dietary.id}
                                    value={dietary.id}
                                    checked={form.dietary.indexOf(dietary.id) >= 0}
                                    onChange={(e) => handleDietaryChange(e)}
                                />
                            );
                        })}

                        <div className="dietary-other grid-full form-check form-check-inline">
                            <div className="d-flex align-items-center">
                                <input onChange={() => setShowOther(!showOther)}
                                    value={0}
                                    checked={showOther}
                                    id="dietary-other"
                                    className="form-check-input" type="checkbox"
                                />
                                <label htmlFor="dietary-other" className="form-check-label">
                                    <TextTranslate name="word-other" fallback="Other" textOnly/>
                                </label>
                            </div>

                            {showOther && (
                                <input
                                    className="dietary-input form-control m-0"
                                    value={form.other_dietary}
                                    onChange={e => {handleTextInput(e, 'other_dietary')}}
                                />
                            )}
                        </div>

                    </div>
                </div>
            </div>
            <hr />
            <div className="row">
                <div className="col-12">
                    <h3><TextTranslate name="form-medical" fallback="Medical"/></h3>
                    <p><TextTranslate name="form-medical-note" fallback="Please click the toggle if you have specific medical requirements we need to be aware of."/></p>
                    <ToggleSwitch
                        label2={<TextTranslate name="form-medical-requirements" fallback="I have specific medical requirements"/>}
                        onChange={e => {handleSwitch(e, 'medical_needs')}}
                        isChecked={form.medical_needs}
                        id="medicalRequirements"
                    />
                </div>
                {form.medical_needs && (
                    <div className="col-12 mt-3">
                        <div className="form-group">
                            <label className="mb-0"><TextTranslate name="form-additional-comments" fallback="Additional comments"/></label>
                            <small className="d-block mb-2"><TextTranslate name="medical-additional-comments-note" fallback="Please provide any necessary details." textOnly/></small>
                            <textarea
                                onChange={e => {handleTextInput(e, 'medical_comments')}}
                                className="form-control" rows="3" defaultValue={form.medical_comments} />
                        </div>
                    </div>
                )}
            </div>
            <hr />
            <div className="row">
                <div className="col-12">
                    <h3><TextTranslate name="form-mobility" fallback="Mobility"/></h3>
                    <p><TextTranslate name="form-mobility-wheelchair-note" fallback="Please click the toggle if you require a wheelchair access."/></p>
                    <ToggleSwitch
                        label2={<TextTranslate name="form-switch-wheelchair" fallback="I require wheelchair access"/>}
                        isChecked={form.wheelchair}
                        onChange={e => {handleSwitch(e, 'wheelchair')}}
                        id="wheelchair"
                    />
                </div>
                <div className="col-12">
                    <hr />
                    <div className="form-group">
                        <h3><TextTranslate name="form-additional-comments" fallback="Additional comments"/></h3>
                        <p><TextTranslate name="form-additional-comments-note" fallback="Please specify any necessary details, or inform us of any other mobility issues you have."/></p>
                        <textarea
                            onChange={e => {handleTextInput(e, 'mobility_comments')}}
                            className="form-control" rows="3" defaultValue={form.mobility_comments} />
                    </div>
                </div>
            </div>

            {!isAdmin ?
                <StepsNavigation
                    fnPrevious={handlePrevious}
                    fnNext={handleNext}
                /> : null
            }
        </>
    )
}

const mapStateToProps = (state, componentProps) => ({
    guests: state.guests?.list || componentProps.guest,
    dietaries: state.dietary?.list || componentProps.dietaries,
    activeGuest: state.guests?.activeGuest,
    activeStep: state.guests?.activeStep,
    formData: state.guests?.formData || componentProps.formData,
    currentLanguage: state.translations?.currentLanguage,
});

export default connect(mapStateToProps)(SpecialRequirements);
